import { atom } from 'recoil'

import { CrashDetectionLockedModalProps } from './types'

const initCrashDetectionLockedModal: CrashDetectionLockedModalProps = {
  isVisible: false,
  errorCode: null,
  ownerName: '',
  ownerEmployeeCode: '',
  lockedCrashInfoId: '',
}

const crashDetectionLockedModalAtom = atom({
  key: 'crashDetectionLockedModalAtom',
  default: initCrashDetectionLockedModal,
})

export default crashDetectionLockedModalAtom
